// extracted by mini-css-extract-plugin
export var footer = "_lr-0";
export var inherit = "_lr-1";
export var input = "_lr-2";
export var modalContent = "_lr-3";
export var quillEditor = "_lr-4";
export var subtitle = "_lr-5";